import { msalInstance, loginRequest } from "../../../util/msal/config";
import { IAuthProvider } from "./IAuthProvider";

export class MsalAuthProvider implements IAuthProvider {
    async login(): Promise<void> {
        // Initiate redirect - this will navigate away from the page
        await msalInstance.loginRedirect(loginRequest);
        // Code after this will not execute due to redirect
        throw new Error("Redirect in progress");
    }

    async logout(): Promise<void> {
        await msalInstance.logoutRedirect();
    }

    getToken(): string | null {
        // Return the ID token, not access token, for backend authentication
        return sessionStorage.getItem("ADToken");
    }

    async refreshToken(): Promise<string | null> {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
            throw new Error("No accounts found");
        }

        try {
            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            });

            sessionStorage.setItem("ADToken", response.idToken);
            sessionStorage.setItem("accessToken", response.accessToken);

            return response.idToken; // Return idToken for backend
        } catch (error) {
            console.error("Silent token acquisition failed:", error);
            throw error;
        }
    }

    handleRedirect(dispatch: any, externalSignIn: any): void {
        msalInstance
            .handleRedirectPromise()
            .then(loginResponse => {
                console.log("MSAL Redirect Response:", loginResponse);

                if (loginResponse && loginResponse.account) {
                    const account = loginResponse.account;
                    const loginRequestWithAccount = {
                        ...loginRequest,
                        account: account
                    };

                    return msalInstance
                        .acquireTokenSilent(loginRequestWithAccount)
                        .then(accessTokenResponse => {
                            sessionStorage.setItem("ADToken", loginResponse.idToken);
                            sessionStorage.setItem("accessToken", accessTokenResponse.accessToken);
                            dispatch(externalSignIn(loginResponse.idToken));
                        })
                        .catch(error => {
                            console.error("Error acquiring token silently:", error);
                        });
                }
            })
            .catch(error => {
                console.error("Error handling redirect:", error);
            });
    }
}
